<template>
  <div id="history-compare">
    <div ref="container"></div>
  </div>
</template>

<script>
// import * as Diff2Html from 'diff2html';
import beautify from "js-beautify";
import JsDiff from "diff";
import { Diff2HtmlUI } from "diff2html/lib/ui/js/diff2html-ui-slim.js";

// Requires `npm install highlight.js`
import "highlight.js/styles/github.min.css";
import "diff2html/bundles/css/diff2html.min.css";

export default {
  props: {
    version: {
      type: Object,
    },
    compareVersion: {
      type: Object,
    },
  },
  data() {
    return {
      diffHtml: "",
    };
  },
  watch: {
    version: {
      handler(newVal) {
        if (newVal != null && this.compareVersion != null) {
          this.$nextTick(() => {
            this.generateDiff();
          });
        }
      },
      deep: true,
      immediate: true,
    },
    compareVersion: {
      handler(newVal) {
        if (newVal != null && this.version != null) {
          this.$nextTick(() => {
            this.generateDiff();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    generateDiff() {
      const diffElement = this.$refs.container;

      // 使用 Diff2HTML 生成差异视图
      const diffString = this.createDiff();

      const diff2htmlUi = new Diff2HtmlUI(diffElement, diffString, {
        drawFileList: false,
        outputFormat: "side-by-side", // 可以改为 'line-by-line' 如果需要
        highlight: true,
      });
      diff2htmlUi.draw();
      diff2htmlUi.highlightCode();
    },
    createDiff() {
      let oldHtml = "";
      let newHtml = "";
      let oldFileName =
        this.$common.formatTimesToTime(this.version.created_at) || "左边版本";
      let newFileName =
        this.$common.formatTimesToTime(this.compareVersion.created_at) ||
        "右边版本";

      try {
        const versionJson = JSON.parse(this.version.module_json);
        const compareVersionJson = JSON.parse(this.compareVersion.module_json);
        oldHtml = versionJson.rich_text;
        newHtml = compareVersionJson.rich_text;
      } catch (error) {
        this.$message.error(error.message);
      }

      const beautifyConfig = {
        indent_size: 2,
        inline: [],
        // wrap_line_length: 20
      };

      // 使用 beautify 格式化 HTML
      const formattedOldHtml = beautify.html(oldHtml, beautifyConfig);
      const formattedNewHtml = beautify.html(newHtml, beautifyConfig);

      const diff = JsDiff.createTwoFilesPatch(
        oldFileName,
        newFileName,
        formattedOldHtml,
        formattedNewHtml,
        "",
        "",
        { context: Number.MAX_SAFE_INTEGER }
      );

      return diff;
    },
  },
};
</script>

<style>
#history-compare .d2h-code-line,
#history-compare .d2h-code-line-ctn {
  /* white-space: pre-wrap;
  word-break: break-all; */
  /* word-wrap: break-word;
  white-space: pre-wrap; */
}

#history-compare .d2h-file-side-diff {
  overflow-x: scroll;
  overflow-y: scroll;
  max-height: 550px;
}

#history-compare .d2h-code-wrapper {
  position: relative;
}
</style>